import {createActionGroup, emptyProps, props} from '@ngrx/store';
import {User} from '../../../model/user';
import {UserPage} from '../../../model/user-page';


export const UserPageActions = createActionGroup({
  source: 'UserPage API',
  events: {
    Load: props<{ userId: string }>(),
    loaded: props<{ userPage: UserPage }>(),
    ErrorLoading: props<{ error: Error }>(),
  }
});

export const UserLoadActions = createActionGroup({
  source: 'UserLoad API',
  events: {
    Load: props<{ userId: string }>(),
    Loaded: props<{ user: UserPage, loading: boolean }>(),
    NotFound: emptyProps(),
    ErrorLoading: props<{ error: Error }>(),
  }
});

export const UserListLoadActions = createActionGroup({
  source: 'UserListLoad API',
  events: {
    LoadUser: emptyProps(),
    LoadUsersByLOB: props<{ lobNumber: string }>(),
    Loaded: props<{ users: User[] }>(),
    ErrorLoading: props<{ error: Error }>(),
  }
});


